export function keyToLabel(key: string): string {
    return key
        .split('_')
        .map(piece => piece.substr(0, 1).toUpperCase() + piece.substr(1))
        .join(' ')
}